<div mat-dialog-title>
  <span>{{ data.title }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="content">
  <p *ngIf="data.message" class="message">{{ data.message }}</p>

  <p *ngIf="data.actionDescription" class="action-description">
    {{ data.actionDescription }}
  </p>

  <q9-credit-balance-warning
    #creditWarning
    [hidden]="!(isFree() || hasSubscription())"
    [actionKey]="data.actionKey"></q9-credit-balance-warning>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button (click)="cancel()">
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button (click)="confirm()" [disabled]="!creditWarning.canProceed()">
    {{ data.confirmButtonText }}
  </q9-primary-button>
</mat-dialog-actions>
